export default "__VITE_ASSET__Cf6N9I4$__"